import React, { useEffect, useState } from "react";

import { login, getUser } from "../store/actions/homeActions";

import ReactHtmlParser from 'react-html-parser';

import { connect } from "react-redux";
import { compose } from "redux";
import { Link } from "react-router-dom";


import { Redirect } from 'react-router-dom';

import { languageService } from "./lang/Lang.js";



function Settings(props) {

  const { userdata, profile, loggedin, getUserFN } = props;
  const uaeMode = /^(dev-)?uae\.sahra\.ai$/i.test(window.location.hostname);


  const [langselected, setlangselected] = useState("en");





  useEffect(() => {
    // Update the document title using the browser API




    getUserFN(profile.id);

    setlangselected(languageService.getLanguage());


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //console.log(userdata);

  return loggedin ? (
    <div className="container" style={{ marginTop: "60px" }}>
      <div className="columns" style={{ margin: 13, background: "white", borderRadius: "3px" }}>
        <div
          className="column"
          style={{
            color: "black",
            padding: "10px !important",
          }}
        >

          <div style={{ height: "10px" }}></div>
          <p>{languageService.translate('settings.t1')}: <b>{userdata && userdata.length > 0 ? userdata[0].email : null}</b></p>
          <div style={{ height: "10px" }}></div>
          <p>{languageService.translate('settings.t2')}: <b>{userdata && userdata.length > 0 && userdata[0].premium === 1 ? "Premium" : "Free"}</b></p>
          <div style={{ height: "10px" }}></div>

          {/*
          {userdata && userdata.length > 0 && userdata[0].premium === 1 ? <div></div> : <div><p>{languageService.translate('settings.t3')}: <b>{userdata && userdata.length > 0 && userdata[0].credito}</b></p>
            <div style={{ height: "20px" }}></div></div>}
        */}









          {uaeMode ? <div>
            <p>To unsubscribe, please send the cancellation keyword to the short code in below format:</p>
            <p style={{ marginTop: "10px" }}><b>C SRA</b> to <b>1111</b> for Daily</p>
          </div> : userdata && userdata.length > 0 && userdata[0].premium === 1 ? <div><form action={`${process.env.REACT_APP_API_URL || "https://api.pigu.chat"}/api/cancel_stripe`} method="POST">
            <input
              type="hidden"
              id="session_id"
              name="session_id"
              value={userdata && userdata.length > 0 && userdata[0].id}
            />
            <div className="field">
              <button
                className="ovvvee"
                style={{
                  padding: "10px 15px",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  border: 0,
                  color: "#fff",
                  background: "#F35875",
                  borderRadius: "3px",
                }}
              >
                {languageService.translate('settings.t4')}
              </button>
            </div></form></div> : <div>
            <p>{languageService.translate('settings.t5')}</p>
            <div style={{ height: "10px" }}></div>
            <div className="field">
              <form action={`${process.env.REACT_APP_API_URL || "https://api.pigu.chat"}/stripe`} method="POST">
                <input
                  type="hidden"
                  id="session_id"
                  name="session_id"
                  value={userdata && userdata.length > 0 && userdata[0].id}
                />

                <input
                  type="hidden"
                  id="email"
                  name="email"
                  value={userdata && userdata.length > 0 && userdata[0].email}
                />
                <button
                  className="ovvvee"
                  style={{
                    padding: "10px 15px",
                    fontSize: "1.1rem",
                    fontWeight: "600",
                    border: 0,
                    color: "#fff",
                    background: "#F35875",
                    borderRadius: "3px",
                  }}
                >
                  👉 {languageService.translate('settings.t6')}
                </button>
              </form>
            </div>
            <div style={{ height: "4px" }}></div>

            <p>{languageService.translate('settings.t7')}</p>


            <div style={{ height: "20px" }}></div>

          </div>}



        </div>
      </div>

      <div style={{ height: "20px" }}></div>


      <div style={{ color: "#3C2200", padding: "10px" }}>
        &copy; {process.env.REACT_APP_COPYRIGHT_YEAR || "2025"} {process.env.REACT_APP_COMPANY_NAME || "Adjomo Global"} • <Link to="/terms">{ReactHtmlParser(languageService.translate('home.footer1'))}</Link> • <Link to="/privacy">{ReactHtmlParser(languageService.translate('home.footer2'))}</Link> • <a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL || "hello@sahra.ai"}`}>{ReactHtmlParser(languageService.translate('home.footer3'))}</a> • <select value={langselected} onChange={(v) => {
          languageService.setLanguage(v.target.value);
          setlangselected(v.target.value);
          setTimeout(() => {
            //window.location.reload();
            window.location.href = "/settings";

          }, 500);
        }} style={{ maxWidth: "100px" }}><option value="en">🇬🇧 English</option><option value="de">🇩🇪 Deutsch</option><option value="it">🇮🇹 Italiano</option><option value="ar">🇸🇦 العربية</option><option value="es">🇪🇸 Español</option><option value="fr">🇫🇷 Français</option><option value="bg">🇧🇬 Български</option><option value="sr">🇷🇸 Српски</option></select>


        <div style={{ height: "30px" }}></div>

      </div>


    </div >) : <Redirect to="/login" />;

}

const mapStateToProps = (state) => {
  return {
    profile: state.home.profile,
    errore: state.home.errore,
    loggedin: state.home.loggedin,
    userdata: state.home.userdata,



  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loginFN: (username, pwd) =>
      dispatch(login(username, pwd)),
    getUserFN: (id) =>
      dispatch(getUser(id))

  };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Settings);
